var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate 1",
    clipPath: "url(#clip0_1489_4926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5601 8.00017C12.5601 8.28692 12.4507 8.57364 12.2321 8.79226L5.35243 15.6719C4.9148 16.1095 4.20525 16.1095 3.76779 15.6719C3.33033 15.2344 3.33033 14.525 3.76779 14.0874L9.85534 8.00017L3.768 1.91294C3.33055 1.4753 3.33055 0.765966 3.768 0.328545C4.20546 -0.109303 4.91501 -0.109303 5.35265 0.328545L12.2324 7.20808C12.4509 7.4268 12.5601 7.71352 12.5601 8.00017Z",
    fill: "#666666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1489_4926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 16) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.e6677c74a0431e0b6e599f99c0d522f6.svg";
export { ForwardRef as ReactComponent };